
import { ModuleInfo } from "../../fabrix/types";
import { icons } from './icons';
import translationJson from './translations.json';
import { FabrixSocketsService } from "../../fabrix/services/socket/fbx-socket.service";
import { RequireAuth } from "../../fabrix/components/authentication/auth-validation";
import { FabrixIcon } from "../../fabrix/common/icons";

export const initSockets = () => {
  let service = FabrixSocketsService.instance;
  service.init("tcm", ["tcm-run"]);
}

const moduleRoutes = (): ModuleInfo => {

  return {
    path: "/tcm/",
    label: "TRANSVERSAL_COSTING",
    name: 'tr-costing',
    icon: "",
    id: "bd9ce2f1-7606-4a3a-b038-534ecfeea96c", //Must match the ID from modules.json.

    lazy: async () => {
      const Page = (await import("./")).default;
      return {
        element: <RequireAuth roles={[]}><Page /></RequireAuth>,
      }
    },
    translations: translationJson,
    icons: icons,
    children: [
      {
        path: "/tcm/",
        label: "HOME",
        name: 'home',
        id: "fa1855dc-d9c2-4db1-ba79-21751ee6f37f",
        hide: true,
        description: "TCM_MASTER_HOME_DESC",
        lazy: async () => {
          const Page = (await import("./routes/home")).default;
          return {
            element: <RequireAuth roles={[]}><Page /></RequireAuth>,
          }
        }
      },
      {
        path: "/tcm/master-group",
        label: "TCM_MASTER_GROUPS",
        name: 'master-group',
        icon: 'tcm-master-group',
        description: "TCM_MASTER_GROUPS_LIST_DESC",
        id: "a82c295e-788d-4210-bb40-42b93c4bf8e6",
        order: 2,
        lazy: async () => {
          const Page = (await import("./routes/master-group")).default;
          return {
            element: <RequireAuth roles={[]}><Page /></RequireAuth>,
          }
        }
      },
      {
        path: "/tcm/master-group/:id",
        label: "TCM_MASTER_GROUP_MANAGEMENT",
        name: 'master-group-management',
        description: "TCM_MASTER_GROUP_MANAGEMENT_DESC",
        icon: 'tcm-master-group-management',
        id: "c1985d2a-8301-44dd-888e-fc9512046943",
        hide: true,
        lazy: async () => {
          const Page = (await import("./routes/master-group/management")).default;
          return {
            element: <RequireAuth roles={[]}><Page /></RequireAuth>,
          }
        }
      },
      {
        path: "/tcm/master-group/:id/items",
        label: "MASTER_GROUP_ITEMS",
        name: 'master-group-items',
        icon: 'tcm-master-group-items',
        description: "TCM_MASTER_GROUP_ITEMS_DESC",
        id: "0e0d1b68-a1d1-4a6c-a629-0e1e85a1fa86",
        hide: true,
        lazy: async () => {
          const Page = (await import("./routes/master-group/items")).default;
          return {
            element: <RequireAuth roles={[]}><Page /></RequireAuth>,
          }
        }
      },
      {
        path: "/tcm/response",
        label: "TCM_RESPONSES",
        name: 'response',
        icon: 'tcm-responses',
          description: "TCM_RESPONSES_LIST_DESC",
        id: "46d5b6aa-dd18-4131-bb61-ccf81d0398fa",
        order: 4,
        lazy: async () => {
          const Page = (await import("./routes/response/response-view")).default;
          return {
            element: <RequireAuth roles={[]}><Page /></RequireAuth>,
          }
        }
      },
      {
        path: "/tcm/response/:id/",
        label: "RESPONSE_HOME",
        name: 'response-items',
        icon: 'tcm-bid-items',
        description: "TCM_RESPONSE_ITEMS_DESC",
        id: "76df6d8f-23cd-487b-be78-f5c909168f1e",
        hide: true,
        lazy: async () => {
          const Page = (await import("./routes/response/responses")).default;
          return {
            element: <RequireAuth roles={[]}><Page /></RequireAuth>,
          }
        }
      },
      {
        path: "/tcm/response/:id/items",
        label: "TCM_RESPONSE_ITEMS",
        name: 'response-items',
          description: "TCM_RESPONSE_ITEMS_DESC",
        icon: 'tcm-responses-items',
        id: "5b30c5d7-0c29-4efe-a49d-27b96b50653b",
        hide: true,
        lazy: async () => {
          const Page = (await import("./routes/response/response-data")).default;
          return {
            element: <RequireAuth roles={[]}><Page /></RequireAuth>,
          }
        }
      },
      {
        path: "/tcm/response/:id/reports",
        label: "TCM_RESPONSE_REPORTS",
        name: 'response-reports',
        description: "TCM_RESPONSE_REPORTS_DESC",
        icon: 'tcm-reports',
        id: "7776a0d2-e7b9-4fe5-a24f-e5a430d01048",
        hide: true,
        lazy: async () => {
          const Page = (await import("./routes/response/response-report")).default;
          return {
            element: <RequireAuth roles={[]}><Page /></RequireAuth>,
          }
        }
      },
      {
        path: "/tcm/master-group/:id/sheets",
        label: "TCM_SHEET_MANAGEMENT_TITLE",
        name: 'master-group-sheets',
        description: "TCM_SHEET_MANAGEMENT_DESCRIPTION",
        icon: 'tcm-template',
        id: "e70fd2d3-f633-4ebe-95bb-d5e549549e8b",
        hide: true,
        lazy: async () => {
          const Page = (await import("./routes/master-group/sheets/sheet-management")).default;
          return {
            element: <RequireAuth roles={[]}><Page /></RequireAuth>,
          }
        }
      },
      {
        path: "/tcm/schedule",
        label: "TCM_PRICING_SCHEDULES",
        name: 'schedules',
        icon: 'tcm-schedules',
          description: "TCM_PRICING_SCHEDULES_LIST_DESC",
        id: "d798b6c6-7579-4359-992d-8463e2e6aa72",
        order: 3,
        lazy: async () => {
          const Page = (await import("./routes/schedule/table")).default;
          return {
            element: <RequireAuth roles={[]}><Page /></RequireAuth>,
          }
        }
      },
      {
        path: "/tcm/schedule/:id/items",
        label: "PRICING_SCHEDULE_ITEMS",
        name: 'bids-items',
        icon: 'tcm-bid-items',
        id: "9f1f84bd-bb3b-472f-a8cc-0aa3dc03b6cb",
        hide: true,
        lazy: async () => {
          const Page = (await import("./routes/schedule/schedule-items")).default;
          return {
            element: <RequireAuth roles={[]}><Page /></RequireAuth>,
          }
        }
      },
      {
        path: "/tcm/schedule/:id/",
        label: "PRICING_SCHEDULE_HOME",
        name: 'schedule-items',
        icon: 'tcm-schedule-items',
        id: "6fd16b16-3894-425b-a62c-5490f18f5fa1",
        hide: true,
        lazy: async () => {
          const Page = (await import("./routes/schedule/home")).default;
          return {
            element: <RequireAuth roles={[]}><Page /></RequireAuth>,
          }
        }
      },
       
      {
        path: "/tcm/response/:scheduleId/:id/",
        label: "PRICING_RESPONSE_HOME",
        name: 'response-goals',
        icon: 'tcm-response',
        id: "add5c460-d366-48f5-92d8-9d092e15f0fb",
        hide: true,
        lazy: async () => {
          const Page = (await import("./routes/response/response-item")).default;
          return {
            element: <RequireAuth roles={[]}><Page /></RequireAuth>,
          }
        }
      },
      {
        path: "/tcm/response/:scheduleId/:id/validate",
        label: "PRICING_RESPONSE_VALIDATE_GOALS",
        name: 'validate-goals',
        icon: 'tcm-validate-goals',
        id: "1486bb3f-4535-4b78-ab66-cc0d2d0aad3f",
        hide: true,
        lazy: async () => {
          const Page = (await import("./routes/response/goal-validation")).default;
          return {
            element: <RequireAuth roles={[]}><Page /></RequireAuth>,
          }
        }
      },
      {
        path: "/tcm/schedule/:id/goals",
        label: "PRICING_SCHEDULE_GOALS",
        name: 'pricing-schedule-goals',
        icon: 'tcm-specific-goals',
        id: "52958b4b-a099-4e8c-94ee-a61951916bdc",
        hide: true,
        lazy: async () => {
          const Page = (await import("./routes/schedule/sheet-goals")).default;
          return {
            element: <RequireAuth roles={[]}><Page /></RequireAuth>,
          }
        }
      },
      {
        path: "/tcm/schedule/:id/publish",
        label: "PRICING_SCHEDULE_PUBLISH",
        name: 'pricing-schedule-publish',
        icon: 'tcm-etender',
        id: "a1640278-79fa-4688-bf24-1e933fae4285",
        hide: true,
        lazy: async () => {
          const Page = (await import("./routes/schedule/e-tender")).default;
          return {
            element: <RequireAuth roles={[]}><Page /></RequireAuth>,
          }
        }
      },
      {
        path: "/tcm/supplier",
        label: "TCM_SUPPLIER",
        name: 'supplier',
        icon: 'tcm-supplier',
        description: "TCM_SUPPLIER_DESC",
        id: "5857b11b-3d39-45ea-8f61-9f597add6998",
        order: 1,
        lazy: async () => {
          const Page = (await import("./routes/supplier")).default;
          return {
            element: <RequireAuth roles={[]}><Page /></RequireAuth>,
          }
        }
      },
      {
        path: "/tcm/history",
        label: "TCM_HISTORY",
        name: 'history',
        description: "TCM_HISTORY_DESC",
        icon: 'tcm-history',
        id: "154df5ea-989f-486c-ba38-ee51042601c1",
        order: 5,
        lazy: async () => {
          const Page = (await import("./routes/history")).default;
          return {
            element: <RequireAuth roles={[]}><Page /></RequireAuth>,
          }
        }
      },
      {
        path: "/tcm/admin",
        label: "TCM_ADMIN",
        name: 'admin',
        icon: 'tcm-admin',
        description: "TCM_ADMIN_DESC",
        id: "9410a07d-d978-48fb-95bc-53c1ff376392",
        order: 0,
        lazy: async () => {
          const Page = (await import("./routes/admin")).default;
          return {
            element: <RequireAuth roles={[]}><Page /></RequireAuth>,
          }
        },
      },
      {
        path: "/tcm/admin/specific-goals",
        label: "TCM_SPECIFIC_GOALS",
        name: 'tcm-specific-goals',
        icon: 'tcm-specific-goals',
        id: "36877a5f-075d-479e-b43f-93e394403926",
        hide: true,
        group: "tcm-admin",

        lazy: async () => {
          const Page = (await import("./routes/admin/specific-goals")).default;
          return {
            element: <RequireAuth roles={[]}><Page /></RequireAuth>,
          }
        }
      },
      {
        path: "/tcm/admin/e-tender-profiles",
        label: "TCM_E_TENDER_PROFILES",
        name: 'tcm-etender-profiles',
        icon: 'tcm-etender-profile',
        id: "f4e2b3e1-5d3b- fourth-4c9b-8f7e-2c3e5d6a7b8c",
        hide: true,
        group: "tcm-admin",

        lazy: async () => {
          const Page = (await import("./routes/admin/e-tender")).default;
          return {
            element: <RequireAuth roles={[]}><Page /></RequireAuth>,
          }
        }
      },
      {
        path: "/tcm/admin/category",
        label: "TCM_CATEGORY",
        name: 'category',
        icon: 'tcm-category',
        id: "0289bbdd-b8b5-4b2c-953e-a4f450958148",
        hide: true,
        group: "tcm-admin",

        lazy: async () => {
          const Page = (await import("./routes/admin/category")).default;
          return {
            element: <RequireAuth roles={[]}><Page /></RequireAuth>,
          }
        }
      },

      {
        path: "/tcm/admin/default-fields",
        label: "TCM_ADMIN_DEFAULT_FIELDS",
        name: 'default-fields',
        icon: 'tcm-fields',
        id: "0c2ad194-4c5c-4692-9cc8-72cc2f3f997a",
        hide: true,
        group: "tcm-admin",
        lazy: async () => {
          const Page = (await import("./routes/admin/default-fields")).default;
          return {
            element: <RequireAuth roles={[]}><Page /></RequireAuth>,
          }
        }
      },
      {
        path: "/tcm/admin/response-status",
        label: "TCM_RESPONSE_STATUS",
        name: 'response-status',
        icon: 'tcm-response-status',
        id: "4fc2a57d-f42d-44aa-820d-c7a362d2c037",
        hide: true,
        group: "tcm-admin",

        lazy: async () => {
          const Page = (await import("./routes/admin/response-status")).default;
          return {
            element: <RequireAuth roles={[]}><Page /></RequireAuth>,
          }
        }
      },
      {
        path: "/tcm/admin/rejection-reason",
        label: "TCM_REJECTION_REASON",
        name: 'rejection-reason',
        icon: 'tcm-rejection-reason',
        id: "54c381d6-f027-447b-b742-b74ced1e4705",
        hide: true,
        group: "tcm-admin",

        lazy: async () => {
          const Page = (await import("./routes/admin/rejection-reason")).default;
          return {
            element: <RequireAuth roles={[]}><Page /></RequireAuth>,
          }
        }
      },
       {
        path: "/tcm/admin/schedule-status",
        label: "TCM_SCHEDULE_STATUS",
        name: 'schedule-status',
        icon: 'tcm-schedule-status',
        id: "8b3339e6-5088-4cab-9455-395dbbf10f06",
        hide: true,
        group: "tcm-admin",

        lazy: async () => {
          const Page = (await import("./routes/admin/schedule-status")).default;
          return {
            element: <RequireAuth roles={[]}><Page /></RequireAuth>,
          }
        }
      },
      {
        path: "/tcm/admin/configuration",
        label: "TCM_CONFIGURATION",
        name: 'configuration',
        icon: 'tcm-configuration',
        id: "443b6649-5ba0-4c3e-9dcc-b6594fba1533",
        hide: true,
        group: "tcm-admin",
        roles: ["system-admin","admin"],
        lazy: async () => {
          const Page = (await import("./routes/admin/configuration")).default;
          return {
            element: <RequireAuth roles={["system-admin","admin"]}><Page /></RequireAuth>,
          }
        }
      },
      {
        path: "/tcm/documentation",
        label: "TCM_USER_DOCUMENTATION",
        name: 'user-documentation',
        icon: FabrixIcon.documentation,
        id: "ffb5b77a-0f38-49bc-9bb1-4d6651a414eb",
        hide: true,

        lazy: async () => {
          const Page = (await import("./routes/documentation/user")).default;
          return {
            element: <RequireAuth roles={[]}><Page /></RequireAuth>,
          }
        }
      },
      {
        path: "/tcm/documentation/user",
        label: "TCM_USER_DOCUMENTATION",
        name: 'user-documentation',
        icon: FabrixIcon.documentation,
        id: "521894c0-54fd-482c-b771-1af843c52ec0",
        newTab: true,

        lazy: async () => {
          const Page = (await import("./routes/documentation/user")).default;
          return {
            element: <RequireAuth roles={[]}><Page /></RequireAuth>,
          }
        }
      },
      {
        path: "/tcm/documentation/user/:file",
        label: "TCM_USER_DOCUMENTATION",
        name: 'user-documentation',
        icon: FabrixIcon.documentation,
        id: "63792e52-66cd-43ee-8710-397c953e4628",
        hide: true,

        lazy: async () => {
          const Page = (await import("./routes/documentation/user")).default;
          return {
            element: <RequireAuth roles={[]}><Page /></RequireAuth>,
          }
        }
      },
      {
        path: "/tcm/documentation/testing",
        label: "TCM_TESTING_DOCUMENTATION",
        name: 'user-documentation',
        icon: FabrixIcon.documentation,
        id: "9fa4fb6a-0da1-4b4d-8848-424671ef4a70",
        newTab: true,
        

        lazy: async () => {
          const Page = (await import("./routes/documentation/testing")).default;
          return {
            element: <RequireAuth roles={[]}><Page /></RequireAuth>,
          }
        }
      },
       {
        path: "/tcm/documentation/testing/:file",
        label: "TCM_TESTING_DOCUMENTATION",
        name: 'user-documentation',
        icon: FabrixIcon.documentation,
        id: "793ab54b-cb2f-44a2-ac8b-3908253e6397",
        hide: true,

        lazy: async () => {
          const Page = (await import("./routes/documentation/testing")).default;
          return {
            element: <RequireAuth roles={[]}><Page /></RequireAuth>,
          }
        }
      }



    ]
  }

}



export default moduleRoutes;
